module.exports = __webpack_public_path__ + "static/media/apple.5ffad8ff.png";